export default __webpack_public_path__ + "static/media/netvrk-v2-8.a7ff2a44.jpg";